import React from "react"
const BookingContext = React.createContext({
    DateStatus : [] ,
    setDateStatus : () => {} ,
    weeklyCell : [],
    setWeeklyCell : () => {},
    DailyCell : [],
    setDailyCell : () => {}
})
export default BookingContext